"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CompanyEnrollmentStatus;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const Screen_1 = __importDefault(require("../components/Screen"));
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const cancelable_promise_1 = require("cancelable-promise");
const BenefitRenewal_1 = __importDefault(require("../api/BenefitRenewal"));
const native_1 = require("@react-navigation/native");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const Loading_1 = __importDefault(require("../components/Loading"));
const Card_1 = __importDefault(require("../components/Card"));
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const react_i18next_1 = require("react-i18next");
const react_native_config_1 = __importDefault(require("react-native-config"));
const Files_1 = require("../shared/Files");
const Helper_1 = require("../Helper");
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const react_native_paper_1 = require("react-native-paper");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const Benefits_1 = __importDefault(require("../api/Benefits"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        incompleteLabel: {
            backgroundColor: `${THEME.Gray}88`,
            borderRadius: 2,
            marginVertical: 4,
            marginHorizontal: 4,
            paddingHorizontal: 6,
            paddingVertical: 2
        },
        incompleteLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        completeLabel: {
            backgroundColor: THEME.Secondary,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        completeLabelText: {
            color: THEME.White,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        ineligibleLabel: {
            backgroundColor: `${THEME.Amber}AD`,
            borderRadius: 2,
            marginVertical: 4,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        ineligibleLabelText: {
            color: THEME.Text,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        expiredLabel: {
            backgroundColor: `${THEME.Red}`,
            borderRadius: 2,
            paddingHorizontal: 4,
            paddingVertical: 2
        },
        expiredLabelText: {
            color: THEME.White,
            fontSize: (size != 'sm' ? 12 : 10),
            fontWeight: '500'
        },
        legendItem: {
            userSelect: 'none',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 0,
            alignSelf: 'stretch',
            borderRadius: 4,
            minHeight: 34,
            paddingVertical: 6,
            justifyContent: 'center',
            alignItems: 'center',
        },
        legendTotal: {
            color: THEME.Text,
            fontSize: 16
        },
        legendRow: {
            flexDirection: 'row',
            width: '100%',
            marginVertical: 16,
            marginTop: 24,
        },
        legendItemOff: {
            opacity: 0.35,
        }
    });
};
function EmployeeEnrollmentStatusItem(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingVertical: 6 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, alignItems: 'center', flexDirection: 'row' }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, paddingLeft: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text }, children: props.employeeStatus.fullName.replace(/ +(?= )/g, '') }), !!props.locationLabel && ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight, fontSize: (size != 'sm' ? 12 : 11), marginTop: 2 }, children: props.locationLabel }))] }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text }, children: (props.employeeStatus.enrollmentType === 'Life Event Enrollment' && props.uiText.le
                                        || props.employeeStatus.enrollmentType === 'Benefit Enrollment' && props.uiText.newHire
                                        || props.employeeStatus.enrollmentType === 'Open Enrollment' && props.uiText.oe) }), (!!props.employeeStatus.enrollmentCategory && props.employeeStatus.enrollmentType === 'Open Enrollment') && ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight, textAlign: 'center', fontSize: (size != 'sm' ? 12 : 11), marginTop: 2 }, children: (props.employeeStatus.enrollmentCategory === 'Annual' && props.uiText.annualOE
                                        || props.employeeStatus.enrollmentCategory === 'Medical Only' && props.uiText.medOnly
                                        || props.employeeStatus.enrollmentCategory === 'FSA/HSA' && props.uiText.fsaHsa) }))] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text }, children: !props.employeeStatus.endDate ?
                                    "—" :
                                    Helper_1.Helper.FormatDate(props.employeeStatus.endDate, false) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, alignItems: 'center', justifyContent: 'center' }, children: [props.employeeStatus.enrollmentStatus === 'Complete' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.completeLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.completeLabelText, children: props.uiText.complete }) })), props.employeeStatus.enrollmentStatus === 'Incomplete' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.incompleteLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.incompleteLabelText, children: props.uiText.incomplete }) })), props.employeeStatus.enrollmentStatus === 'Ineligible' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.ineligibleLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.ineligibleLabelText, children: props.uiText.ineligible }) })), props.employeeStatus.enrollmentStatus === 'Expired' && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.expiredLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.expiredLabelText, children: props.uiText.expired }) }))] })] }) }), !props.isLastItem && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [STYLES.separator, { marginVertical: 6, marginHorizontal: -12 }] }))] }));
}
function CompanyEnrollmentStatus(props) {
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const styles = useStyles();
    const [status, setStatus] = react_1.default.useState(null);
    const [refreshing, setRefreshing] = react_1.default.useState(false);
    const isFocused = (0, native_1.useIsFocused)();
    const promise = react_1.default.useRef(null);
    const locationsPromise = react_1.default.useRef(null);
    const [enrollmentInfoList, setEnrollmentInfoList] = react_1.default.useState([]);
    const [locations, setLocations] = react_1.default.useState([]);
    const [remoteLocations, setRemoteLocations] = react_1.default.useState([]);
    const [location, setLocation] = react_1.default.useState('');
    const [completeToggle, setCompleteToggle] = react_1.default.useState(true);
    const [incompleteToggle, setIncompleteToggle] = react_1.default.useState(true);
    const [ineligibleToggle, setIneligibleToggle] = react_1.default.useState(true);
    const [expiredToggle, setExpiredToggle] = react_1.default.useState(true);
    const [searchText, setSearchText] = react_1.default.useState('');
    const [searchQuery, setSearchQuery] = react_1.default.useState('');
    const [isDownloading, setIsDownloading] = react_1.default.useState(false);
    const [sort, setSort] = react_1.default.useState({ field: 'employee', direction: 'asc' });
    const [isPending, startTransition] = react_1.default.useTransition();
    const uiText = react_1.default.useMemo(() => ({
        complete: t('company:labels.complete').toUpperCase(),
        ineligible: t('company:labels.ineligible').toUpperCase(),
        incomplete: t('company:labels.incomplete').toUpperCase(),
        expired: t('company:labels.expired').toUpperCase(),
        oe: t('company:labels.openEnrollment'),
        le: t('company:labels.lifeEvent'),
        newHire: t('company:labels.newHire'),
        annualOE: t('company:labels.annualOE'),
        medOnly: t('company:labels.medOnly'),
        fsaHsa: t('company:labels.fsaHsa'),
        downloading: t('company:buttons.downloading…'),
    }), [t]);
    react_1.default.useEffect(() => {
        const id = setTimeout(() => {
            startTransition(() => setSearchQuery(searchText));
        }, 200);
        return () => clearTimeout(id);
    }, [searchText, startTransition]);
    const onSort = (field) => {
        setSort(current => ({
            field,
            direction: current.field === field && current.direction === 'asc' ? 'desc' : 'asc'
        }));
    };
    const onRefresh = react_1.default.useCallback(() => {
        setRefreshing(true);
        refresh().then(() => setRefreshing(false));
        return () => {
            promise.current?.cancel();
            locationsPromise.current?.cancel();
        };
    }, []);
    const refresh = react_1.default.useCallback(async () => {
        promise.current?.cancel();
        locationsPromise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Benefits_1.default.getEnrollmentStatusInfoList(token)));
        locationsPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => BenefitRenewal_1.default.getLocations(token)));
        Promise.all([
            promise.current,
            locationsPromise.current
        ]).then(([data, dataLocations]) => {
            const dataInfo = data.sort((a, b) => {
                var namePartsA = a?.fullName?.split(' ');
                var namePartsB = b?.fullName?.split(' ');
                return namePartsA[namePartsA.length - 1]?.localeCompare(namePartsB[namePartsB.length - 1] || '');
            });
            setEnrollmentInfoList(dataInfo ?? []);
            const remoteLocations = dataLocations.filter((location) => location.name?.toLowerCase().includes('remote') || location.code?.toLowerCase().includes('remote'));
            setRemoteLocations(remoteLocations.map((location) => location.code));
            const nonRemoteLocations = dataLocations.filter((location) => !(location.name?.toLowerCase().includes('remote') || location.code?.toLowerCase().includes('remote')));
            const mappedLocations = [
                ...nonRemoteLocations.map((location) => ({
                    label: location.name,
                    value: location.code,
                })),
                ...(remoteLocations.length > 0
                    ? [{ label: 'Remote', value: 'Remote' }]
                    : []),
            ];
            setLocations([
                { label: t('company:labels.all'), value: '' },
                ...mappedLocations.sort((a, b) => a.label.localeCompare(b.label))
            ]);
            setStatus('done');
        })
            .catch((e) => {
            setStatus(e == 404 ? 'done' : 'error');
        });
    }, [userContext]);
    const handleExportCsv = react_1.default.useCallback(async () => {
        if (isDownloading)
            return;
        try {
            setIsDownloading(true);
            const token = await userContext.getToken();
            const date = new Date().toISOString().slice(0, 10);
            const filename = `company-enrollment-${date}.csv`;
            const url = `${react_native_config_1.default.API_URL}/benefits/enrollment/status/export`;
            const headers = {
                Authorization: `Bearer ${token.token}`,
                ...(token.client && { 'Nextep-Client': token.client }),
                ...(token.prospect && { 'Nextep-Prospect': token.prospect }),
                Accept: 'text/csv, text/plain, */*',
            };
            const { path } = await Files_1.Files.SaveToDownloadsWithResult(filename, 'text/csv', url, headers);
            if (react_native_1.Platform.OS === 'android') {
                react_native_1.ToastAndroid.show(t('company:hints.csvSaved', { filename }), react_native_1.ToastAndroid.LONG);
            }
            else if (react_native_1.Platform.OS === 'ios') {
                react_native_1.Alert.alert(t('company:labels.exportCsv'), t('company:hints.csvSaved', { filename }), [
                    { text: 'View', onPress: () => Files_1.Files.previewIOS(path) },
                    { text: 'OK', style: 'cancel' },
                ]);
            }
        }
        catch {
            react_native_1.Alert.alert(t('company:labels.exportCsv'), t('company:hints.exportCsvFail'));
        }
        finally {
            setIsDownloading(false);
        }
    }, [userContext, t, isDownloading]);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel?.();
        };
    }, [refresh, isFocused]);
    const { completeEmployees, incompleteEmployees, ineligibleEmployees, expiredEmployees } = react_1.default.useMemo(() => {
        const all = enrollmentInfoList ?? [];
        const byLocation = (e) => !location || e.location === location || (location === 'Remote' && remoteLocations.includes(e.location));
        return {
            completeEmployees: all.filter((e) => e.enrollmentStatus?.toLowerCase() === 'complete' && byLocation(e)),
            incompleteEmployees: all.filter((e) => e.enrollmentStatus?.toLowerCase() === 'incomplete' && byLocation(e)),
            ineligibleEmployees: all.filter((e) => e.enrollmentStatus?.toLowerCase() === 'ineligible' && byLocation(e)),
            expiredEmployees: all.filter((e) => e.enrollmentStatus?.toLowerCase() === 'expired' && byLocation(e)),
        };
    }, [enrollmentInfoList, location, remoteLocations]);
    const totalComplete = completeEmployees?.length ?? 0;
    const totalIncomplete = incompleteEmployees?.length ?? 0;
    const totalIneligible = ineligibleEmployees?.length ?? 0;
    const totalIneligibleNonFiltered = enrollmentInfoList.filter((e) => e.enrollmentStatus?.toLowerCase() === 'ineligible').length ?? 0;
    const totalExpired = expiredEmployees?.length ?? 0;
    const rawTokens = react_1.default.useMemo(() => {
        return searchQuery
            .trim()
            .toLowerCase()
            .split(/\s+/)
            .map(t => t.replace(/,/g, ''))
            .filter(Boolean);
    }, [searchQuery]);
    const searchTokens = react_1.default.useMemo(() => {
        return rawTokens.filter(t => t.length > 2);
    }, [rawTokens]);
    const isMultiTokenQuery = rawTokens.length > 1;
    const hasIncompleteToken = isMultiTokenQuery && searchTokens.length < rawTokens.length;
    const indexedAllEmployees = react_1.default.useMemo(() => {
        const all = enrollmentInfoList ?? [];
        const indexed = all.map((e) => {
            const nameParts = e.fullName.split(' ');
            return {
                employee: e,
                status: (e.enrollmentStatus ?? '').toLowerCase(),
                location: e.location ?? '',
                fullName: e.fullName,
                words: e.fullName.replace(/ +(?= )/g, '').toLowerCase().split(/\s+/).filter(Boolean),
                first: (nameParts[0] ?? '').toUpperCase(),
                last: (nameParts[nameParts.length - 1] ?? '').toUpperCase(),
                enrollmentType: e.enrollmentType,
                endDate: e.endDate,
            };
        });
        const dir = sort.direction === 'asc' ? 1 : -1;
        indexed.sort((a, b) => {
            let valA, valB;
            switch (sort.field) {
                case 'employee':
                    valA = a.last + a.first;
                    valB = b.last + b.first;
                    break;
                case 'enrollmentType':
                    valA = a.enrollmentType;
                    valB = b.enrollmentType;
                    break;
                case 'status':
                    valA = a.status;
                    valB = b.status;
                    break;
                case 'endDate':
                    valA = a.endDate || '';
                    valB = b.endDate || '';
                    break;
                default:
                    return 0;
            }
            if (valA < valB)
                return -1 * dir;
            if (valA > valB)
                return 1 * dir;
            if (sort.field !== 'employee') {
                if (a.last + a.first < b.last + b.first)
                    return -1;
                if (a.last + a.first > b.last + b.first)
                    return 1;
            }
            return 0;
        });
        return indexed;
    }, [enrollmentInfoList, sort]);
    const employeeStatusesFiltered = react_1.default.useMemo(() => {
        const byLocation = (loc) => !location ||
            loc === location ||
            (location === 'Remote' && remoteLocations.includes(loc));
        const base = indexedAllEmployees.filter(x => {
            if (!byLocation(x.location))
                return false;
            if (x.status === 'complete' && !completeToggle)
                return false;
            if (x.status === 'incomplete' && !incompleteToggle)
                return false;
            if (x.status === 'ineligible' && !ineligibleToggle)
                return false;
            if (x.status === 'expired' && !expiredToggle)
                return false;
            return true;
        });
        if (searchTokens.length === 0) {
            return base.map(x => x.employee);
        }
        if (hasIncompleteToken)
            return [];
        const strict = base.filter(x => searchTokens.every(t => x.words.some(w => w.startsWith(t))));
        if (isMultiTokenQuery)
            return strict.map(x => x.employee);
        if (strict.length > 0)
            return strict.map(x => x.employee);
        return base
            .filter(x => x.fullName.includes(searchTokens[0]))
            .map(x => x.employee);
    }, [
        indexedAllEmployees,
        location,
        remoteLocations,
        completeToggle,
        incompleteToggle,
        ineligibleToggle,
        expiredToggle,
        searchTokens,
        isMultiTokenQuery,
        hasIncompleteToken,
    ]);
    const keyExtractor = react_1.default.useCallback((item, idx) => {
        const id = item.employeeId;
        return id ? String(id) : `${item.fullName ?? ''}-${idx}`;
    }, []);
    const renderEmployee = react_1.default.useCallback(({ item, index }) => ((0, jsx_runtime_1.jsx)(EmployeeEnrollmentStatusItem, { employeeStatus: item, locationLabel: remoteLocations.includes(item.location) ? 'Remote' : item.location, uiText: uiText, isLastItem: index === employeeStatusesFiltered.length - 1 })), [uiText, employeeStatusesFiltered.length]);
    const cardMargin = (size == 'sm' ? 8 : 16);
    const portalEnabled = userContext?.adminExperience == 'both' || userContext?.adminExperience == 'elevate-edge';
    return ((0, jsx_runtime_1.jsxs)(Screen_1.default, { onRefresh: onRefresh, refreshing: refreshing, containerStyle: (portalEnabled && size != 'sm') ? {
            backgroundColor: THEME.CardBackground,
            padding: 0
        } : { padding: 0 }, scrollStyle: (portalEnabled && size != 'sm') ? {
            backgroundColor: THEME.CardBackground
        } : null, children: [!portalEnabled &&
                (0, jsx_runtime_1.jsx)(react_native_1.Image, { resizeMode: 'cover', source: size != 'sm' ? Theme_1.IMAGES.RenewalBackgroundWeb : Theme_1.IMAGES.RenewalBackground, style: { width: '100%', height: 'auto', aspectRatio: size != 'sm' ? 11.2 : 5.6, marginTop: size != 'sm' ? 12 : 4, borderRadius: size != 'sm' ? 4 : 0 } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: size != 'sm' ? {
                    margin: (portalEnabled ? (columns > 1 ? cardMargin : 0) : (columns > 1 ? -cardMargin : 0)),
                    marginTop: (portalEnabled ? (columns > 1 ? cardMargin : 0) : cardMargin)
                } : { marginBottom: 3 }, children: (0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, paddingRight: 8 }, children: (0, jsx_runtime_1.jsx)(CardTitle_1.default, { "aria-label": t('company:labels.benefitsEnrollmentStatus'), title: t('company:labels.benefitsEnrollmentStatus') }) }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: isDownloading, onPress: handleExportCsv, style: ({ pressed }) => [
                                        {
                                            paddingVertical: 6,
                                            paddingHorizontal: 10,
                                            borderRadius: 4,
                                            borderWidth: 1,
                                            borderColor: THEME.Primary,
                                            opacity: isDownloading ? 0.6 : 1,
                                        },
                                        pressed ? STYLES.pressedOpacity : null,
                                    ], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontWeight: '600' }, children: isDownloading ? uiText.downloading : t('company:buttons.downloadCsv') }) })] }), status === 'done' ? ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 8, flexDirection: size != 'sm' ? 'row' : 'column', width: '100%' }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('employees:labels.search'), mode: "outlined", dense: true, label: t('employees:labels.search'), left: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { disabled: true, style: { alignSelf: 'center', justifyContent: 'center', marginTop: Helper_1.Helper.isPlatformWeb ? -1 : 0 }, icon: ({ color }) => (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.MagnifyingGlass, color: color, size: 16 }), theme: { ...THEME, colors: { onSurfaceDisabled: THEME.Text } } }), onChangeText: (value) => setSearchText(value), value: searchText, style: [
                                                STYLES.input,
                                                {
                                                    flex: 1,
                                                    marginRight: size != 'sm' ? 8 : 0,
                                                    marginBottom: size != 'sm' ? 0 : 8,
                                                },
                                            ], contentStyle: { paddingVertical: 0, justifyContent: 'center' } }), locations.length > 2 && ((0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: locations, label: t('employees:text.employeeLocs'), setValue: (value) => setLocation(value), value: location }))] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.legendRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setCompleteToggle(!completeToggle), style: ({ pressed }) => [styles.legendItem, (completeToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.completeLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.completeLabelText, children: t("company:labels.complete").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: totalComplete }) })] }), totalIneligibleNonFiltered > 0 &&
                                            (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setIneligibleToggle(!ineligibleToggle), style: ({ pressed }) => [styles.legendItem, { marginHorizontal: 8 }, (ineligibleToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.ineligibleLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.ineligibleLabelText, children: t("company:labels.ineligible").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: totalIneligible }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setIncompleteToggle(!incompleteToggle), style: ({ pressed }) => [styles.legendItem, { marginHorizontal: totalIneligibleNonFiltered > 0 ? 0 : 8 }, (incompleteToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.incompleteLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.incompleteLabelText, children: t("company:labels.incomplete").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: totalIncomplete }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onPress: () => setExpiredToggle(!expiredToggle), style: ({ pressed }) => [styles.legendItem, { marginLeft: totalIneligibleNonFiltered > 0 ? 8 : 0 }, (expiredToggle ? { backgroundColor: THEME.SmokeWhite } : null), (pressed ? STYLES.pressedOpacity : null)], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.expiredLabel, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.expiredLabelText, children: t("company:labels.expired").toUpperCase() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { accessible: true, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { accessible: false, style: styles.legendTotal, children: totalExpired }) })] })] }), (0, jsx_runtime_1.jsx)(TableHeader_1.default, { style: { marginBottom: 6 }, sort: sort, onSort: onSort, columns: [
                                        { flex: 1, label: t('company:labels.employee'), align: 'flex-start', indent: 30, sortKey: 'employee' },
                                        { flex: 1, label: t('common:text.type'), align: 'center', sortKey: 'enrollmentType' },
                                        { flex: 1, label: t('company:labels.endDate'), align: 'center', sortKey: 'endDate' },
                                        { flex: 1, label: t('company:labels.status'), align: 'center', sortKey: 'status' },
                                    ] }), employeeStatusesFiltered?.length > 0 ? ((0, jsx_runtime_1.jsx)(react_native_1.FlatList, { scrollEnabled: false, data: employeeStatusesFiltered, renderItem: renderEmployee, keyExtractor: keyExtractor, contentContainerStyle: { paddingBottom: 8 }, keyboardShouldPersistTaps: "handled", removeClippedSubviews: false, initialNumToRender: 12, maxToRenderPerBatch: 12, updateCellsBatchingPeriod: 16, windowSize: 7 })) : ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { alignItems: 'center', justifyContent: 'center', marginVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CircleQuestion, size: 36, color: THEME.ImageNull }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: 14, color: THEME.TextNull, marginTop: 4 }, children: t('company:text.noOEEmployees') })] }))] })) : ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, onRetry: onRefresh, loading: status === 'loading', error: status === 'error' }))] }) })] }));
}
